export function emptyFn() {
  return null;
}
